<template>
  <div id="content" v-show="!loading">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction" />
    <form>
      <div class="inner">
        <p class="paging">
          <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
        </p>

        <p class="buttons">
          <a v-if="$_deleteActionAllowed" class="btn btn_action btn_delete" :title="'Smazat' | translate"
             @click.prevent.stop="deleteEntity" v-translate>Smazat</a>
        </p>

        <h1 v-if="entity.name">{{ entity.name }}</h1>
      </div>
      <div class="responsiveTabs">
        <device-boot-config-form
            :entity="entity"
            :operator-options="operatorOptions"
            :isEditable="isEditable"
            @saveEntity="submitForm"
        />
      </div>
    </form>
  </div>
</template>

<script>
import detailActions from "@/components/mixins/detail-actions"
import DeviceBootConfigForm from "./forms/DeviceBootConfigForm.vue";

export default {
  name: 'DeviceBootConfigDetail',
  mixins: [detailActions],
  components: {DeviceBootConfigForm},
  created(DeviceBootConfigService, OperatorService) {
    this.entityService = DeviceBootConfigService;
    this.operatorService = OperatorService
    this.getOperators(true, true)
    this.createdInit()
  },
  data() {
    return {
      moduleName: 'deviceBootConfigs',
      entityName: 'device_boot_config',
      loading: true,
      updateFields: [
        'name',
        'image_url',
        'image_version',
        'splash_url',
        'splash_version',
        'is_theme',
        'id_operator',
        'id_device',
      ]
    }
  },
  computed:{
    isEditable(){
      return this.$_loggedUser_action_allowed('devices', 'update', ['OWN', 'OWN_AND_GLOBAL', 'GLOBAL', 'ALL']);
    },
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceBootConfigs/DeviceBootConfigDetail.vue